module.exports = __webpack_public_path__ + "static/media/palm-busd.4699bdc9.png";